export default "__VITE_ASSET__CucU1Sv6__"